import { render, staticRenderFns } from "./taglist.vue?vue&type=template&id=4c6aa956&"
import script from "./taglist.vue?vue&type=script&lang=js&"
export * from "./taglist.vue?vue&type=script&lang=js&"
import style0 from "./taglist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports